import { request } from '@umijs/max';
import type {
  CurrentUserContextResponse,
  OrgStructuresForSwitchResponse,
  SwitchUserContextRequest,
  SwitchUserContextResponse,
  UserContextsResponse,
} from '../types/userContext.types';

const path = '/api/v1/subject';

export async function getAvailableUserContexts(options?: { [key: string]: any }) {
  return request<UserContextsResponse>(`${path}/user-contexts`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getCurrentUserContext(options?: { [key: string]: any }) {
  return request<CurrentUserContextResponse>(`${path}/current-context`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function switchUserContext(
  body: SwitchUserContextRequest,
  options?: { [key: string]: any },
) {
  return request<SwitchUserContextResponse>(`${path}/switch-context`, {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function getOrgStructuresForSwitch(
  params?: { page?: number; per_page?: number },
  options?: { [key: string]: any },
) {
  return request<OrgStructuresForSwitchResponse>(`${path}/org-structures/`, {
    method: 'GET',
    params: {
      page: params?.page ?? 1,
      per_page: params?.per_page ?? 100,
    },
    ...(options || {}),
  });
}

export async function logoutUserContext(options?: { [key: string]: any }) {
  return request<SwitchUserContextResponse>(`${path}/logout-context`, {
    method: 'POST',
    ...(options || {}),
  });
}
